import cn from 'classnames';

export const fieldBlockClassName = cn('flex', 'items-center', 'justify-between');
export const fieldClassName = cn('w-[280px]');
export const fieldLabelClassName = cn('text-1color', 'text-[14px]', 'font-[500]', 'leading-[15px]');
